import { render, staticRenderFns } from "./InputMultiSelect.vue?vue&type=template&id=4faa87d4&"
import script from "./InputMultiSelect.vue?vue&type=script&lang=js&"
export * from "./InputMultiSelect.vue?vue&type=script&lang=js&"
import style0 from "./InputMultiSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports